/** @file activeVariants: the variant flags a PoseParams variant mask turns on. */

/** Clears `out` and adds `puppetVariants[i]` for every set bit i of `variantMask`; returns `out`. */
export function activeVariants(puppetVariants: readonly string[], variantMask: number, out: Set<string>): Set<string> {
  out.clear();
  for (let i = 0; i < puppetVariants.length && i < 31; i++) {
    const name = puppetVariants[i];
    if (name !== undefined && (variantMask & (1 << i)) !== 0) out.add(name);
  }
  return out;
}
